module.exports = "<div class=\"layout-box-container\">\n  <ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/layout-box/layout-box.component.html
// module id = 1188
// module chunks = 0